import {useMessages} from "i18n";
import {Ghost} from "contacts/components/Ghost";
import {Card, Column} from "./PanelLoading.styles";

/**
 * The loading fallback shown INSIDE the {@link ./FeaturePanel} while a lazy feature body chunk is
 * fetched (ui#150). The panel shell itself is eager (App-level), so the panel slides in instantly; this
 * skeleton only stands in for the (heavier, lazy) body, so it reuses the shared {@link Ghost} pulse
 * idiom in a framed card.
 *
 * Dumb view (epic #26): no logic; the pulse respects `prefers-reduced-motion` via `Ghost`. A WARM open
 * (body already prefetched) resolves before this paints.
 */
export function PanelLoading() {
	const {common} = useMessages();
	return (
		<Column role="status" aria-label={common.loadingPage}>
			<Card aria-hidden="true">
				<Ghost $w="40%" $h="14px"/>
				<Ghost $w="100%" $h="44px" $r="10px"/>
				<Ghost $w="100%" $h="44px" $r="10px"/>
				<Ghost $w="100%" $h="44px" $r="10px"/>
			</Card>
		</Column>
	);
}
